var map = {
	"./AD.svg": 57311,
	"./AE.svg": 45230,
	"./AF.svg": 77229,
	"./AG.svg": 78284,
	"./AI.svg": 90554,
	"./AL.svg": 43607,
	"./AM.svg": 45574,
	"./AO.svg": 484,
	"./AR.svg": 85345,
	"./AS.svg": 49808,
	"./AT.svg": 15695,
	"./AU.svg": 71966,
	"./AW.svg": 36668,
	"./AX.svg": 99835,
	"./AZ.svg": 30841,
	"./BA.svg": 63279,
	"./BB.svg": 84252,
	"./BD.svg": 39794,
	"./BE.svg": 54435,
	"./BEFR.svg": 60791,
	"./BENL.svg": 3305,
	"./BF.svg": 97392,
	"./BG.svg": 32929,
	"./BH.svg": 22038,
	"./BI.svg": 85863,
	"./BJ.svg": 37652,
	"./BM.svg": 47419,
	"./BN.svg": 96680,
	"./BO.svg": 78425,
	"./BQ.svg": 4895,
	"./BR.svg": 25868,
	"./BS.svg": 24813,
	"./BT.svg": 54594,
	"./BW.svg": 74961,
	"./BY.svg": 13572,
	"./BZ.svg": 48068,
	"./CA.svg": 95320,
	"./CAFR.svg": 83512,
	"./CC.svg": 59514,
	"./CD.svg": 83045,
	"./CF.svg": 40247,
	"./CG.svg": 34918,
	"./CH.svg": 2449,
	"./CI.svg": 88064,
	"./CK.svg": 45346,
	"./CL.svg": 73869,
	"./CM.svg": 26508,
	"./CN.svg": 5535,
	"./CO.svg": 90894,
	"./CR.svg": 5531,
	"./CS.svg": 36714,
	"./CU.svg": 44180,
	"./CV.svg": 92391,
	"./CW.svg": 45526,
	"./CX.svg": 25326,
	"./CY.svg": 11824,
	"./CZ.svg": 1219,
	"./DE.svg": 33593,
	"./DJ.svg": 33150,
	"./DK.svg": 53199,
	"./DM.svg": 50529,
	"./DO.svg": 48803,
	"./DZ.svg": 38478,
	"./EC.svg": 91268,
	"./EE.svg": 34362,
	"./EG.svg": 14584,
	"./EM.svg": 50818,
	"./EN.svg": 21713,
	"./ER.svg": 40661,
	"./ES.svg": 98676,
	"./ET.svg": 48091,
	"./FI.svg": 54059,
	"./FJ.svg": 98872,
	"./FK.svg": 74377,
	"./FM.svg": 93943,
	"./FO.svg": 67365,
	"./FR.svg": 8048,
	"./GA.svg": 94076,
	"./GB.svg": 73103,
	"./GD.svg": 54081,
	"./GE.svg": 55632,
	"./GF.svg": 21731,
	"./GG.svg": 72338,
	"./GH.svg": 9621,
	"./GI.svg": 64692,
	"./GL.svg": 80345,
	"./GM.svg": 98600,
	"./GN.svg": 79963,
	"./GP.svg": 22125,
	"./GQ.svg": 70316,
	"./GR.svg": 49343,
	"./GS.svg": 11406,
	"./GT.svg": 76881,
	"./GU.svg": 36320,
	"./GW.svg": 12834,
	"./GY.svg": 36932,
	"./HK.svg": 2515,
	"./HN.svg": 35566,
	"./HR.svg": 29802,
	"./HT.svg": 80404,
	"./HU.svg": 36661,
	"./ID.svg": 76199,
	"./IE.svg": 12374,
	"./IL.svg": 53615,
	"./IM.svg": 9886,
	"./IN.svg": 64061,
	"./IO.svg": 74588,
	"./IQ.svg": 28474,
	"./IR.svg": 96585,
	"./IS.svg": 92344,
	"./IT.svg": 81527,
	"./JE.svg": 43723,
	"./JM.svg": 39411,
	"./JO.svg": 92785,
	"./JP.svg": 35862,
	"./KE.svg": 88524,
	"./KG.svg": 39118,
	"./KH.svg": 92201,
	"./KI.svg": 57336,
	"./KM.svg": 34020,
	"./KN.svg": 77143,
	"./KP.svg": 64961,
	"./KR.svg": 97859,
	"./KW.svg": 39678,
	"./KY.svg": 9480,
	"./KZ.svg": 90843,
	"./LA.svg": 41437,
	"./LB.svg": 87262,
	"./LC.svg": 49839,
	"./LI.svg": 30997,
	"./LK.svg": 76871,
	"./LR.svg": 86702,
	"./LS.svg": 91455,
	"./LT.svg": 49248,
	"./LU.svg": 34430,
	"./LV.svg": 41154,
	"./LY.svg": 36325,
	"./MA.svg": 54158,
	"./MC.svg": 13068,
	"./MD.svg": 69811,
	"./ME.svg": 55586,
	"./MG.svg": 79072,
	"./MH.svg": 84279,
	"./MK.svg": 79684,
	"./ML.svg": 44395,
	"./MM.svg": 39130,
	"./MN.svg": 64713,
	"./MO.svg": 89208,
	"./MP.svg": 15855,
	"./MQ.svg": 36926,
	"./MR.svg": 65373,
	"./MS.svg": 36828,
	"./MT.svg": 64483,
	"./MU.svg": 31442,
	"./MV.svg": 96833,
	"./MW.svg": 98384,
	"./MX.svg": 78951,
	"./MY.svg": 39414,
	"./MZ.svg": 52373,
	"./NA.svg": 70299,
	"./NC.svg": 70681,
	"./NE.svg": 26535,
	"./NF.svg": 55028,
	"./NG.svg": 99957,
	"./NI.svg": 12067,
	"./NL.svg": 84510,
	"./NO.svg": 12957,
	"./NP.svg": 70362,
	"./NR.svg": 36792,
	"./NU.svg": 31863,
	"./NZ.svg": 26656,
	"./OM.svg": 88448,
	"./PA.svg": 50705,
	"./PE.svg": 54477,
	"./PF.svg": 25358,
	"./PG.svg": 30111,
	"./PH.svg": 43576,
	"./PK.svg": 82411,
	"./PL.svg": 20260,
	"./PM.svg": 74981,
	"./PN.svg": 75846,
	"./PR.svg": 46162,
	"./PS.svg": 84099,
	"./PT.svg": 9468,
	"./PW.svg": 88495,
	"./PY.svg": 3641,
	"./QA.svg": 93746,
	"./RO.svg": 50953,
	"./RS.svg": 51613,
	"./RU.svg": 50723,
	"./RW.svg": 83073,
	"./SA.svg": 75176,
	"./SB.svg": 56539,
	"./SC.svg": 30922,
	"./SD.svg": 86197,
	"./SE.svg": 41268,
	"./SG.svg": 73238,
	"./SH.svg": 30657,
	"./SI.svg": 32208,
	"./SK.svg": 48914,
	"./SL.svg": 82845,
	"./SM.svg": 70652,
	"./SN.svg": 49679,
	"./SO.svg": 70750,
	"./SR.svg": 61867,
	"./ST.svg": 91525,
	"./SV.svg": 18103,
	"./SY.svg": 12896,
	"./SZ.svg": 3635,
	"./TC.svg": 10519,
	"./TD.svg": 21336,
	"./TF.svg": 57466,
	"./TG.svg": 72075,
	"./TH.svg": 45196,
	"./TJ.svg": 95790,
	"./TK.svg": 24223,
	"./TL.svg": 58336,
	"./TM.svg": 94289,
	"./TN.svg": 73922,
	"./TO.svg": 79091,
	"./TR.svg": 41366,
	"./TT.svg": 16008,
	"./TV.svg": 6378,
	"./TZ.svg": 38878,
	"./UA.svg": 88950,
	"./UG.svg": 63592,
	"./UK.svg": 51164,
	"./US.svg": 14980,
	"./UY.svg": 43374,
	"./UZ.svg": 91725,
	"./VA.svg": 68131,
	"./VC.svg": 69857,
	"./VE.svg": 72527,
	"./VG.svg": 98749,
	"./VI.svg": 72443,
	"./VN.svg": 11092,
	"./VU.svg": 72447,
	"./WF.svg": 49139,
	"./WS.svg": 16254,
	"./YE.svg": 98054,
	"./YT.svg": 77908,
	"./ZA.svg": 3111,
	"./ZM.svg": 88643,
	"./ZW.svg": 88873,
	"./areas/EU.svg": 64687,
	"./areas/NA.svg": 91886,
	"./areas/RW.svg": 55852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24111;